import CatfishGoogleAd from "@components/CatfishGoogleAd/CatfishGoogleAd";
import Footer from "@components/Footer/Footer";
import GAData from "@components/GAData/GAData";
import GoogleAd from "@components/GoogleAd/GoogleAd";
import Header from "@components/Header/Header";
import MobileHeader from "@components/Header/MobileHeader";
import MetaTags from "@components/MetaTags/MetaTags";
import { AdvertisementTypeEnum, GoogleAdsSlotFactory } from "@constants/ads";
import useParams from "@hooks/useSafeParams";
import viewportState from "@stores/viewport";
import { ReactElement } from "react";
import { Helmet } from "react-helmet-async";
import { useSnapshot } from "valtio";

import EpapersDefaultLayout from "./EpapersDefaultLayout";

const Epapers = (): ReactElement => {
  const { level1 = "" } = useParams();
  const title = "电子报 - 联合早报、新明日报、U周刊电子版 | 联合早报";
  const description =
    "《联合早报》是全球华文用户信任的媒体，为您提供新加坡本地与国际新闻、观点和解析。《新明日报》是以小市民生活为定位的新加坡晚间报章，贴近社会动态与脉搏。立即订阅电子报，随时随地享受阅报乐趣。";
  const sectionAdsName = `epapers`;
  const { isMobileView, isDesktopView, isInAppBrowser } =
    useSnapshot(viewportState);

  const getAdBlocker = () => {
    if (typeof window !== "undefined") {
      return (window as Window).canRunAds ?? 0;
    }
  };

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <MetaTags
        type="website"
        title={title}
        description={description}
        slug="/"
      ></MetaTags>

      <GAData level2_ga={level1} title={title} adblocker={getAdBlocker()} />

      {isInAppBrowser ? null : (
        <GoogleAd
          rootClassName="masthead-google-ad abm-google-ad"
          type={AdvertisementTypeEnum.ABM}
          slot={GoogleAdsSlotFactory.abm(sectionAdsName)}
        />
      )}

      {isInAppBrowser ? null : (
        <GoogleAd
          rootClassName="masthead-google-ad min-h-[50px] justify-center p-[10px]"
          type={AdvertisementTypeEnum.LB1}
          slot={GoogleAdsSlotFactory.lb1(sectionAdsName)}
        />
      )}

      {!isDesktopView ? (
        isInAppBrowser ? null : (
          <MobileHeader rootClassName="lg:hidden" />
        )
      ) : (
        <Header rootClassName="max-lg:hidden" />
      )}

      <EpapersDefaultLayout />

      {isInAppBrowser ? null : <Footer />}

      {isMobileView ? (
        isInAppBrowser ? null : (
          <CatfishGoogleAd
            slot={GoogleAdsSlotFactory.catfish(sectionAdsName)}
          />
        )
      ) : null}
    </>
  );
};

export default Epapers;
